// extracted by mini-css-extract-plugin
export default {"forgotPasswordContainer":"styles_forgotPasswordContainer__pMw4g","content":"styles_content__zqHsK","continueBtn":"styles_continueBtn__F-dD4"};